import { PageRoot } from './PageRoot';
import { PageContent } from './PageContent';
import { PageHeader } from './PageHeader';
import { PageDivider } from './PageDivider';
import { PageSubTitle } from './PageSubTitle';
import { PageTitle } from './PageTitle';
import { PageSection } from './PageSection';

export const Page = {
    Root: PageRoot,
    Content: PageContent,
    Section: PageSection,
    Header: PageHeader,
    Divider: PageDivider,
    Title: PageTitle,
    SubTitle: PageSubTitle,
}

export * from './PageContent';
export * from './SectionTitle'
export * from './PageToolbar';
export * from './PageSection';



